export default __webpack_public_path__ + "static/comparisons-team-4e7cefaa18d081792526e9b63f3e1241.jpg";